if (!customElements.get('pg-media-carousel')) {
  class PgMediaCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.carouselReady === 'true') return;

      this.viewport = this.querySelector('[data-carousel-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.currentIndex = 0;

      if (!this.viewport || this.slides.length < 2) return;

      this.dataset.carouselReady = 'true';
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };

      this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.goTo(this.currentIndex - 1), options);
      this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.goTo(this.currentIndex + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));

      let frameRequested = false;
      this.viewport.addEventListener('scroll', () => {
        if (frameRequested) return;
        frameRequested = true;
        requestAnimationFrame(() => {
          frameRequested = false;
          const nextIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / Math.max(this.viewport.clientWidth, 1))));
          this.setCurrent(nextIndex);
        });
      }, { ...options, passive: true });

      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-carousel-slide]');
        if (slide) this.goTo(this.slides.indexOf(slide), false);
      }, options);

      this.resizeObserver = new ResizeObserver(() => this.goTo(this.currentIndex, false));
      this.resizeObserver.observe(this.viewport);
      this.setCurrent(0);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    goTo(index, animate = true) {
      const count = this.slides.length;
      const nextIndex = (index + count) % count;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollTo({
        left: this.slides[nextIndex].offsetLeft,
        behavior: animate && !reduceMotion ? 'smooth' : 'auto'
      });
      this.setCurrent(nextIndex);
    }

    setCurrent(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.currentIndex = index;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('pg-media-carousel', PgMediaCarousel);
}
